import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { File } from "@ionic-native/file";
import { FileOpener } from "@ionic-native/file-opener";
import { ChangePasswordModalComponent } from "../change-pass-modal/change-pass-modal";

@Component({
  selector: "dowload-pdf-modal",
  templateUrl: "dowload-pdf-modal.html",
  providers: [SummaryServiceProvider]
})
export class DownloadPDFModalComponent {
  data;
  newSites;
  cpName;
  merchantStatusList: any;
  username: any;
  firstName: any;
  lastName: any;
  status: any;
  password: any;
  cpListData: any = [];
  cpListData1: any;
  resCPListData: any;
  pdfObj = null;
  supportObject1: any = {
    name: "Mohsin",
    phone: "0568103432"
  };
  supportObject2: any = {
    name: "Bikash",
    phone: "0567653172"
  };

  constructor(
    private plt: Platform,
    private file: File,
    private fileOpener: FileOpener,
    public params: NavParams,
    public modalCtrl: ModalController,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
    this.newSites = this.params.get("newSites");
    if (this.newSites) {
      this.summaryService
        .getMerchantsInfo(
          `/api/v0.2/techsupport/collectionpoints?page=0&size=1000&managerUserEntity.companyName=${this.data.value}`
        )
        .then((res: any) => {
          this.resCPListData = res.data.content;
          this.resCPListData = this.resCPListData.map(element => {
            element.merchants.password = "";
            element.isDisabled = true;
            this.newSites.map(elee => {
              if (element.id == elee.id) {
                element.merchants.password = elee.password;
                element.isDisabled = false;
              }
            });
            return element;
          });
          this.cpListData = this.resCPListData.filter(
            ele => ele.status == "NOT_ACTIVE"
          );
        });
    } else {
      this.summaryService
        .getMerchantsInfo(
          `/api/v0.2/techsupport/collectionpoints?page=0&size=1000&managerUserEntity.companyName=${this.data.value}`
        )
        .then((res: any) => {
          this.resCPListData = res.data.content;
          this.resCPListData = this.resCPListData.map(element => {
            element.merchants.password = "";
            element.isDisabled = true;
            return element;
          });
          this.cpListData = this.resCPListData.filter(
            ele => ele.status == "NOT_ACTIVE"
          );
        });
    }
  }

  compareFn(a, b) {
    return a && b ? a === b : a === b;
  }

  isActiveCheckbox(value) {
    if (value === true) {
      this.cpListData = this.resCPListData;
    } else {
      this.cpListData = this.resCPListData.filter(
        ele => ele.status == "NOT_ACTIVE"
      );
    }
  }

  changePassword(item) {
    const modal = this.modalCtrl.create(ChangePasswordModalComponent, {
      data: item
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.resCPListData = this.resCPListData.map(ele => {
          if (ele.id == data.id) {
            ele.merchants.password = data.password;
            ele.isDisabled = false;
          }
          return ele;
        });
      }
    });
    modal.present();
  }

  createPdf() {
    let isSelectedPrintSites = this.cpListData.filter(
      ele => ele.isPrint === true
    );
    let docDefinitionTableValue = isSelectedPrintSites.map((ele, i) => {
      let neweleObj = {
        style: "tableExample",
        table: {
          heights: [20, 20, 15, 15],
          widths: [70, 70],
          body: [
            ["Username", ele.merchants.username],
            ["Password", ele.merchants.password],
            [{ text: "Call Us", colSpan: 2 }],
            [
              {
                text: `${this.supportObject1.name} :    ${this.supportObject1.phone}\n${this.supportObject2.name}  :    ${this.supportObject2.phone}`,
                colSpan: 2
              }
            ]
          ]
        }
      };
      return neweleObj;
    });

    let documentPrint = this.chunk(docDefinitionTableValue, 3);

    let finalPrintDocument = documentPrint.map(ele => {
      let object = {
        stack: [{ columns: ele }],
        unbreakable: true
      };
      return object;
    });

    var dd = {
      content: [finalPrintDocument],
      styles: {
        tableExample: {
          margin: [0, 0, 18, 18]
        }
      }
    };

    this.pdfObj = pdfMake.createPdf(dd);
    this.downloadPdf();
  }

  downloadPdf() {
    if (this.plt.is("cordova")) {
      this.pdfObj.getBuffer(buffer => {
        var blob = new Blob([buffer], { type: "application/pdf" });

        // Save the PDF to the data Directory of our App
        this.file
          .writeFile(this.file.dataDirectory, "siteLabels.pdf", blob, {
            replace: true
          })
          .then(fileEntry => {
            // Open the PDf with the correct OS tools
            this.fileOpener.open(
              this.file.dataDirectory + "siteLabels.pdf",
              "application/pdf"
            );
          });
      });
    } else {
      // On a browser simply use download!
      this.pdfObj.download();
    }
  }

  chunk(array, size) {
    const chunked_arr = [];
    let copied = [...array]; // ES6 destructuring
    const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
    for (let i = 0; i < numOfChild; i++) {
      chunked_arr.push(copied.splice(0, size));
    }
    return chunked_arr;
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/add-sites/dowload-pdf-modal/dowload-pdf-modal.ts